import { forwardRef } from 'react'
import { motion } from 'motion/react'
import { cn } from '@/lib/utils'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  hint?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, label, hint, error, ...props }, ref) => {
  return (
    <div className="space-y-2">
      {label && <label className="text-foreground-muted block text-sm font-medium">{label}</label>}
      <motion.div whileFocus={{ scale: 1.005 }} transition={{ duration: 0.15 }}>
        <input
          ref={ref}
          className={cn(
            'bg-surface border-border w-full rounded-xl border-2 px-5 py-4',
            'text-foreground placeholder:text-foreground-subtle text-lg',
            'transition-all duration-200',
            'focus:border-accent focus:shadow-accent/10 focus:shadow-lg focus:outline-none',
            error && 'border-error focus:border-error focus:shadow-error/10',
            className
          )}
          {...props}
        />
      </motion.div>
      {hint && !error && <p className="text-foreground-subtle text-sm">{hint}</p>}
      {error && (
        <motion.p initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="text-error text-sm">
          {error}
        </motion.p>
      )}
    </div>
  )
})

Input.displayName = 'Input'
